module.exports = __webpack_public_path__ + "static/media/sound-wave.381bb519.png";